module.exports = __webpack_public_path__ + "img/cancelcriteria.a82e33e4.svg";